import Info from 'components/common/Info';
import React from 'react';
import styled from 'styled-components/native';

const Dot = styled.View`
  width: 5px;
  height: 5px;
  border-radius: 3px;
  margin-top: 9px;
  background-color: ${(p) => p.theme.colors.black};
`;

export type BulletItem = {
  key: string;
  text: string | React.ReactElement;
};

const BulletList = ({ items }: { items: BulletItem[] }) => (
  <>
    {items.map(({ key, text }, index, arr) => (
      <Info
        key={key}
        icon={<Dot />}
        text={text}
        last={index === arr.length - 1}
      />
    ))}
  </>
);

export default BulletList;
